import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@/common/components/base-app';
import { COMMON_TRANSLATION, HELIX_SUPPORT_EMAIL } from '@/common/constants';
import { ErrorDataProps } from './ErrorData.types';
import { StyledContact, StyledErrorData, StyledMessage } from './ErrorData.styles';

const ErrorData: FC<ErrorDataProps> = ({ css }) => {
  const { t } = useTranslation(COMMON_TRANSLATION);
  const firstLine = t('error_description', { email: HELIX_SUPPORT_EMAIL }).slice(0, 25);
  const secondLine = t('error_description', { email: HELIX_SUPPORT_EMAIL }).slice(25, 57);

  return (
    <StyledErrorData data-testid={'error-data'} css={css}>
      <StyledMessage data-testid={'error-data-message'}>{t('data_unavailable')}</StyledMessage>
      <Box data-testid={'error-data-contact'}>
        <StyledContact>{firstLine}</StyledContact>
        <StyledContact>{secondLine}</StyledContact>
      </Box>
    </StyledErrorData>
  );
};

export default ErrorData;
